import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  subscriptions: [],
  subscriptionsTypes: [],
  subscriptionsLoading: false,
}

let subscriptionsCall = null

const getSubscriptionURL = groupName => {
  const baseURl = '/EmailSubscriptions'
  switch (groupName) {
    case 'acmf-report':
    case 'acmf-analytic-alert':
      return `${baseURl}/acmf`
    case 'maintenance':
      return `${baseURl}/maintenance`
  }
}

const getters = {
  emailSubscriptionsTypes(subscribable) {
    const url = `/EmailSubscriptions/types?subscribable=${subscribable}`
    return axios.get(url)
  },
  emailSubscriptions(subscriptionIds) {
    let emailTypeIds = ''

    subscriptionIds.forEach(emailTypeId => {
      emailTypeIds += `&emailTypeIds=${emailTypeId}`
    })

    const url = `/EmailSubscriptions?${emailTypeIds}`
    return axios.get(url)
  },
}

const saves = {
  emailSubscriptions(subscriptions) {
    if (subscriptionsCall) {
      subscriptionsCall.cancel('Only one group request allowed at a time.')
    }

    subscriptionsCall = axios.CancelToken.source()

    const subscriptionlist = subscriptions.subscriptionsToSave.map(
      subscriptionObj => {
        const { isNew, ...subscriptionObjParams } = subscriptionObj
        // eslint-disable-next-line no-unused-vars
        const { label, ...subscriptionToSave } = subscriptionObjParams

        if (!isNew) {
          // Existing subscription so update
          return axios.put(
            `${getSubscriptionURL(subscriptions.groupName)}/${
              subscriptionToSave.emailTypeId
            }`,
            subscriptionToSave,
            {
              cancelToken: subscriptionsCall.token,
            },
          )
        } else {
          // New Subscription so POST
          return axios.post(
            getSubscriptionURL(subscriptions.groupName),
            subscriptionToSave,
            {
              cancelToken: subscriptionsCall.token,
            },
          )
        }
      },
    )
    return axios.all(subscriptionlist)
  },
}

export default class SubscriptionCenterService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
